import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Account } from 'app/shared/models/account';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class SessionMonitorService {

  private timeoutMinutes = 1;
  private inactiveTimer: any;
  private sessionStartTime: number = Date.now();

  constructor(
    private router: Router,
    private ngZone: NgZone
  ) {
    this.init();
  }

  private init(): void {
    const accountInfo = JSON.parse(localStorage.getItem('account'));
    const sessionVal = accountInfo?.sessionValue;

    if (
      sessionVal != null &&
      String(sessionVal).trim() !== '' &&
      !isNaN(Number(sessionVal)) &&
      Number(sessionVal) !== -1
    ) {
      this.timeoutMinutes = +sessionVal;

      document.addEventListener('visibilitychange', () => {
        this.ngZone.run(() => {
          if (document.hidden) {
            this.startCountdown();
          } else {
            this.clearCountdown();
            this.sessionStartTime = Date.now();
          }
        });
      });
    }
  }

  private startCountdown() {
    this.clearCountdown();

    const timeoutMs = this.timeoutMinutes * 60 * 1000;
    this.inactiveTimer = setTimeout(() => {
      this.handleSessionTimeout();
    }, timeoutMs);
  }

  private clearCountdown() {
    if (this.inactiveTimer) {
      clearTimeout(this.inactiveTimer);
      this.inactiveTimer = null;
    }
  }

  private handleSessionTimeout() {
    this.clearCountdown();
    this.router.navigate(['/session-timeout']);
  }
}
